export default [
  {
    id: '7fa153d4-dab6-49ed-acad-9995c5933033', // id 全局唯一，终身制
    name: 'sceneConfigureVulkan',
    path: '/scene-configure-vulkan',
    meta: { title: '场景配置5.0' },
    layout: 'fullscreen',
    // 根菜单不需要定义 component，由主框架定义
    children: [
      {
        id: '6ffdafb0-4e50-4cb0-9855-bade07d62cee',
        path: 'index',
        name: 'sceneConfigureVulkan',
        component(resolve) {
          require(['./views/index'], resolve)
        },
        meta: {
          title: '场景配置',
          operations: {},
          hidden: true,
        },
      },
    ],
  },
]
